import { Patient } from '../services/profile';
import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import {
  childInfo,
  localizeAge,
  ProfilePatient,
} from '../component/PatientProfile';
import {
  faMars,
  faVenus,
  faVenusMars,
} from '@fortawesome/free-solid-svg-icons';
import { Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Gender = 'F' | 'M' | null;

type PatientProfileProps = {
  patient: Patient;
  fullWidth?: boolean;
};

export const PatientProfile = (props: PatientProfileProps) => {
  const { patient, fullWidth } = props;
  const intl = useIntl();

  const patientInfo = useMemo(
    () =>
      ({
        id: patient.id,
        gender: patient.gender as Gender,
        strengths: patient.strengths,
        communicationLevel: patient.communicationLevel,
        interactionLevel: patient.interactionLevel,
        selfCareAssistanceLevel: patient.selfCareAssistanceLevel,
      } as ProfilePatient),
    [patient],
  );

  const info = useMemo(() => {
    return childInfo(patientInfo, intl);
  }, [intl, patientInfo]);

  const ageInLocalize = useMemo(() => {
    if (!patient.dateOfBirth) return '';
    return localizeAge(patient.dateOfBirth, new Date(), intl);
  }, [patient.dateOfBirth, intl]);

  function makeGenderIcon(gender: string) {
    if (!gender || gender === 'U') return faVenusMars;
    return gender === 'M' ? faMars : faVenus;
  }

  return (
    <Box
      key={patient.id}
      sx={{
        flex: fullWidth ? '0 0 100%' : '0 0 80%',
        mr: 8,
        mb: 4,
        boxShadow: 5,
        backgroundColor: '#fff',
        borderRadius: 2.5,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#00b2a9',
          padding: 4,
          color: '#fff',
        }}
      >
        {ageInLocalize != null ? (
          <Typography variant='body1'>{ageInLocalize}</Typography>
        ) : (
          <Box />
        )}
        <FontAwesomeIcon icon={makeGenderIcon(patient.gender)} />
      </Box>

      <Box sx={{ px: 4, py: 4 }}>{info}</Box>
    </Box>
  );
};
